export const api = {
  BULK_UPLOAD: '/index.php?r=api/v1/transaction/bulk-insert-transaction-on-us/import',
  STATUS_BULK_UPLOAD: '/index.php?r=api/v1/transaction/bulk-insert-transaction-on-us/status-import',
  DOWNLOAD_TEMPLATE: '/index.php?r=api/v1/transaction/bulk-insert-transaction-on-us/download',
};

export const uploadFailed = (ctx, progressSimulation) => {
  ctx.commit('setOnUpload', false);
  ctx.commit(
    'setSnackbar',
    {
      status: true,
      message: 'Upload Failed !',
      icon: 'mdi-alert',
      color: 'red',
    },
    { root: true }
  );
  
  clearInterval(progressSimulation);
  ctx.commit('setProgressTitle', 'Request Failed');
  ctx.commit('setProgressColor', 'red');
  ctx.commit('setPercentage', 0);
  ctx.commit('setFailedResponse', true);
};
